import React from 'react';

import { useRecoilValue } from 'recoil';
import styled from 'styled-components';

import { userDispensariesAtom } from 'src/app/state/user-dispensaries';

import { Text, generalBannerStyles, SMALL_BANNER_HEIGHT } from './shared';

export function useLocationMessageBannerIsVisible() {
  const { selectedLocation } = useRecoilValue(userDispensariesAtom);
  const message = selectedLocation?.Message || '';

  return message !== '';
}

export function LocationMessagingBanner() {
  const { selectedLocation } = useRecoilValue(userDispensariesAtom);
  const isVisible = useLocationMessageBannerIsVisible();

  if (!isVisible) {
    return null;
  }

  return (
    <Banner>
      <Text>
        <span>{selectedLocation?.Message}</span>
      </Text>
    </Banner>
  );
}

const Banner = styled.div`
  background-color: #ff3e51;
  height: ${SMALL_BANNER_HEIGHT}px;
  border-bottom: 1px solid var(--color-grayscale-black);

  ${generalBannerStyles}
`;
